import { css } from '@linaria/core';
import theme from '../../../theme';

export const trigger = css``;
export const contentGap = css``;
export const content = css``;
export const show = css``;
export const left = css``;
export const right = css``;
export const top = css``;
export const bottom = css``;
export const fullWidth = css``;
export const gapless = css``;
export const selected = css`
  background: ${theme.colors.peoople['azul-claro']};
`;

export const item = css`
  padding: 0.5rem 0.75rem;
  &:hover {
    background: ${theme.colors.peoople['azul-claro']};
  }
  &:focus-visible {
    z-index: 1;
  }
  &[disabled] {
    pointer-events: none;
    color: ${theme.colors.neutral[50]};
  }
`;

export const dropdown = css`
  position: relative;
  --dropdown-gap: 0.5rem;

  &.${gapless} {
    --dropdown-gap: 0;
  }

  .${trigger} {
    width: fit-content;
  }

  & .${contentGap} {
    position: absolute;
    left: 0;
    right: 0;
    height: var(--dropdown-gap);
    bottom: calc(var(--dropdown-gap) * -1);
    &.${top} {
      top: calc(var(--dropdown-gap) * -1);
      bottom: unset;
    }
  }

  & .${content} {
    visibility: hidden;
    left: 0;
    opacity: 0;
    transition:
      visibility 0s linear 0.125s,
      opacity 0.125s linear;
    margin-top: var(--dropdown-gap);
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    top: 100%;
    border-width: 1px;
    border-color: ${theme.colors.primary['80']};
    background: #ffffff;
    z-index: 50;
    border-radius: 0.75rem;
    border: 1px solid ${theme.colors.neutral[40]};
    box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.1);

    &.${show} {
      visibility: visible;
      opacity: 1;
      transition-delay: 0s;
    }
    &.${fullWidth} {
      min-width: 100%;
    }
    &.${left} {
      right: unset;
      left: 0;
    }
    &.${right} {
      right: 0;
      left: unset;
    }
    &.${top} {
      top: initial;
      margin-top: 0;
      margin-bottom: var(--dropdown-gap);
      bottom: 100%;
    }
  }
`;
